import {
  AssetTransactionListProps,
  GetAssetTransactionList,
} from '../../../../types/Assets/AssetTransactionalList/AssetTransactionalListTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AllowedHttpMethods, assetTransactionListConfig } from '../../apiList'

const getAssetTransactionList = async (
  prepareObject: AssetTransactionListProps,
): Promise<GetAssetTransactionList> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: assetTransactionListConfig.getAssetTransactionList,
    method: AllowedHttpMethods.post,
    data: {
      assetId: prepareObject.assetId ?? '',
      multipleSearch: prepareObject.multipleSearch ?? '',
      productId: prepareObject.productId ?? '',
      searchByEmpName: prepareObject.searchByEmpName ?? false,
      status: prepareObject.status ?? '',
    },
    params: {
      dateSelection: prepareObject.dateSelection ?? '',
      endIndex: prepareObject.endIndex ?? 20,
      from: prepareObject.from ?? '',
      startIndex: prepareObject.startIndex ?? 0,
      to: prepareObject.to ?? '',
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const assetTransactionalListApi = {
  getAssetTransactionList,
  exportAssetTransactionalHistory: async (
    prepareObject: AssetTransactionListProps,
  ): Promise<Blob | undefined> => {
    const requestConfig = getAuthenticatedRequestConfig({
      url: assetTransactionListConfig.exportAssetTransactionalHistory ?? '',
      method: AllowedHttpMethods.post,
      data: {
        assetId: prepareObject.assetId ?? '',
        multipleSearch: prepareObject.multipleSearch ?? '',
        productId: prepareObject.productId ?? '',
        searchByEmpName: prepareObject.searchByEmpName ?? false,
        status: prepareObject.status ?? '',
      },
      params: {
        dateSelection: prepareObject.dateSelection ?? '',
        from: prepareObject.from ?? '',
        to: prepareObject.to ?? '',
      },
      responseType: 'blob',
    })
    const response = await useAxios(requestConfig)
    return response.data
  },
}

export default assetTransactionalListApi
